import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable, switchMap } from "rxjs";
import { ChangeStatisticsTabUseCase } from "./set-statistics-category.use-case";
import { EStatisticsTab, EStatisticsTimespan } from "./enums";
import { IStatisticsCategoryArgs } from "./interfaces";
import { StatisticsRepository } from "../statistics.repository";
import { IRoundBet } from "../../core/round/interfaces";

@Injectable({
    providedIn: "root"
})
export class GetStatisticsUseCase implements IUseCase<void, Observable<IRoundBet[]>> {
    constructor(private changeStatisticsTabUseCase: ChangeStatisticsTabUseCase,
                private statisticsRepository: StatisticsRepository) {
    }

    execute(): Observable<IRoundBet[]> {
        return this.changeStatisticsTabUseCase.subscribeStatisticsTab()
            .pipe(switchMap((args: IStatisticsCategoryArgs) => {
                    switch (args.category) {
                        case EStatisticsTab.TopBets:
                            return this.statisticsRepository.getTopBet(args.modifier ?? EStatisticsTimespan.Today);
                        case EStatisticsTab.MyBets:
                            return this.statisticsRepository.getMyBets();
                        case EStatisticsTab.AllBets:
                        default:
                            return this.statisticsRepository.get();
                    }
                })
            );
    }
}
